import { render, staticRenderFns } from "./block-assessment-information.vue?vue&type=template&id=0d35d270&scoped=true"
import script from "./block-assessment-information.vue?vue&type=script&lang=js"
export * from "./block-assessment-information.vue?vue&type=script&lang=js"
import style0 from "./block-assessment-information.vue?vue&type=style&index=0&id=0d35d270&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d35d270",
  null
  
)

export default component.exports